const referencePool = [
  // --- DAT User Core References (sanitized for APA7 injection) ---

  {
    key: "Agamben1998",
    authors: "Agamben",
    year: 1998,
    citation: "Agamben, 1998",
    tags: ["political-theory", "biopolitics", "sovereignty"],
    claim_keys: [
      "state of exception",
      "bare life",
      "homo sacer",
      "sovereignty",
      "biopolitics",
    ],
    phrases: ["bare life", "state of exception"],
  },
  {
    key: "Turing1936",
    authors: "Turing",
    year: 1936,
    citation: "Turing, 1936",
    tags: ["logic", "computability", "decidability", "theory-of-computation"],
    claim_keys: ["halting problem", "undecidable", "Turing machine"],
    phrases: ["halting problem", "Turing machine"],
  },
  {
    key: "Church1936",
    authors: "Church",
    year: 1936,
    citation: "Church, 1936",
    tags: ["logic", "lambda-calculus", "computability"],
    claim_keys: ["lambda calculus", "Church–Turing thesis"],
    phrases: ["lambda calculus", "Church–Turing thesis"],
  },
  {
    key: "Godel1931",
    authors: "Gödel",
    year: 1931,
    citation: "Gödel, 1931",
    tags: ["logic", "incompleteness"],
    claim_keys: ["incompleteness", "arithmetization"],
    phrases: ["incompleteness theorem"],
  },
  {
    key: "Rice1953",
    authors: "Rice",
    year: 1953,
    citation: "Rice, 1953",
    tags: ["logic", "computability", "semantics"],
    claim_keys: ["Rice's theorem", "non-trivial semantic properties"],
    phrases: ["Rice's theorem"],
  },
  {
    key: "Floyd1967",
    authors: "Floyd",
    year: 1967,
    citation: "Floyd, 1967",
    tags: ["formal-methods", "verification", "termination"],
    claim_keys: ["program verification", "inductive assertions"],
    phrases: ["inductive assertions"],
  },
  {
    key: "Hoare1969",
    authors: "Hoare",
    year: 1969,
    citation: "Hoare, 1969",
    tags: ["formal-methods", "verification", "logic"],
    claim_keys: ["Hoare logic", "partial correctness", "total correctness"],
    phrases: ["Hoare logic"],
  },
  {
    key: "Cousot1977",
    authors: "Cousot & Cousot",
    year: 1977,
    citation: "Cousot & Cousot, 1977",
    tags: ["formal-methods", "abstract-interpretation", "analysis"],
    claim_keys: ["abstract interpretation", "static analysis"],
    phrases: ["abstract interpretation"],
  },
  {
    key: "LeeJonesBenAmram2001",
    authors: "Lee, Jones, & Ben-Amram",
    year: 2001,
    citation: "Lee, Jones, & Ben-Amram, 2001",
    tags: ["termination", "analysis", "theory-of-computation"],
    claim_keys: ["size-change termination"],
    phrases: ["size-change termination"],
  },
  {
    key: "Sipser2013",
    authors: "Sipser",
    year: 2013,
    citation: "Sipser, 2013",
    tags: ["theory-of-computation", "textbook"],
    claim_keys: ["decidability", "Turing machines", "reductions"],
    phrases: ["Theory of Computation"],
  },
  {
    key: "Ainsworth1978",
    authors: "Ainsworth",
    year: 1978,
    citation: "Ainsworth, 1978",
    tags: ["developmental-psychology", "attachment-theory"],
    claim_keys: [
      "attachment theory",
      "strange situation",
      "secure attachment",
      "insecure attachment",
      "caregiver sensitivity",
    ],
    phrases: ["strange situation", "secure attachment"],
  },
  {
    key: "Aristotle1984",
    authors: "Aristotle",
    year: 1984,
    citation: "Aristotle, 1984",
    tags: ["ontology", "metaphysics", "logic", "ethics"],
    claim_keys: [
      "substance",
      "form and matter",
      "teleology",
      "categories",
      "syllogism",
      "virtue ethics",
    ],
    phrases: ["substance", "teleology"],
  },
  {
    key: "Bachelard2002",
    authors: "Bachelard",
    year: 2002,
    citation: "Bachelard, 2002",
    tags: ["epistemology", "conceptual-change", "science-studies"],
    claim_keys: [
      "conceptual change",
      "reclassification",
      "scientific mentality",
      "epistemological obstacle",
      "rupture with common sense",
      "category shift",
    ],
    phrases: ["epistemological obstacle", "break with common sense"],
  },
  {
    key: "Badiou2005",
    authors: "Badiou",
    year: 2005,
    citation: "Badiou, 2005",
    tags: ["ontology", "mathematics-in-philosophy", "political-philosophy"],
    claim_keys: [
      "event",
      "truth procedures",
      "being and multiplicity",
      "set theory in ontology",
      "fidelity",
    ],
    phrases: ["event", "truth procedure"],
  },
  {
    key: "Bhaskar1993",
    authors: "Bhaskar",
    year: 1993,
    citation: "Bhaskar, 1993",
    tags: ["dialectics", "critical-realism", "ontology", "freedom"],
    claim_keys: [
      "dialectic",
      "absence",
      "emergence",
      "totality",
      "transformational model of social activity",
      "explanatory critique",
      "ontological stratification",
    ],
    phrases: [
      "explanatory critique",
      "transformational model of social activity",
    ],
  },
  {
    key: "Bohr1928",
    authors: "Bohr",
    year: 1928,
    citation: "Bohr, 1928",
    tags: ["quantum-physics", "epistemology"],
    claim_keys: [
      "complementarity",
      "quantum postulate",
      "measurement context",
      "indeterminacy",
    ],
    phrases: ["principle of complementarity"],
  },
  {
    key: "Bourdieu1991",
    authors: "Bourdieu",
    year: 1991,
    citation: "Bourdieu, 1991",
    tags: ["sociology", "power", "language", "practice-theory"],
    claim_keys: [
      "habitus",
      "field",
      "symbolic power",
      "capital (social/cultural)",
      "doxa",
    ],
    phrases: ["symbolic power", "habitus"],
  },
  {
    key: "Bowlby1969",
    authors: "Bowlby",
    year: 1969,
    citation: "Bowlby, 1969",
    tags: ["developmental-psychology", "attachment-theory"],
    claim_keys: [
      "attachment system",
      "internal working model",
      "secure base",
      "separation distress",
    ],
    phrases: ["secure base", "internal working model"],
  },
  {
    key: "Caspi2003",
    authors: "Caspi et al.",
    year: 2003,
    citation: "Caspi et al., 2003",
    tags: [
      "behavioral-genetics",
      "developmental-psychology",
      "gene-environment",
    ],
    claim_keys: [
      "gene × environment interaction",
      "5-HTTLPR",
      "stress reactivity",
      "depression risk",
    ],
    phrases: ["gene × environment interaction"],
  },
  {
    key: "Cartwright1989",
    authors: "Cartwright",
    year: 1989,
    citation: "Cartwright, 1989",
    tags: ["philosophy-of-science", "causation", "metaphysics-of-science"],
    claim_keys: [
      "capacities",
      "ceteris paribus laws",
      "nomological pluralism",
      "model-based explanation",
    ],
    phrases: ["capacities", "ceteris paribus"],
  },
  {
    key: "Chalmers1996",
    authors: "Chalmers",
    year: 1996,
    citation: "Chalmers, 1996",
    tags: ["philosophy-of-mind", "consciousness"],
    claim_keys: [
      "hard problem of consciousness",
      "property dualism",
      "explanatory gap",
      "phenomenal consciousness",
    ],
    phrases: ["hard problem of consciousness"],
  },
  {
    key: "Chalybaus1854",
    authors: "Chalybäus",
    year: 1854,
    citation: "Chalybäus, 1854",
    tags: ["history-of-ideas", "german-idealism", "dialectics"],
    claim_keys: [
      "thesis–antithesis–synthesis (popularization)",
      "interpretation of Hegelian method",
    ],
    phrases: ["thesis–antithesis–synthesis"],
  },
  {
    key: "Churchland1986",
    authors: "Churchland",
    year: 1986,
    citation: "Churchland, 1986",
    tags: ["neurophilosophy", "philosophy-of-mind", "scientific-realism"],
    claim_keys: [
      "eliminative materialism",
      "neural representation",
      "folk psychology critique",
    ],
    phrases: ["eliminative materialism"],
  },
  {
    key: "Crick1994",
    authors: "Crick",
    year: 1994,
    citation: "Crick, 1994",
    tags: ["neuroscience", "consciousness"],
    claim_keys: [
      "neural correlates of consciousness",
      "biological basis of mind",
    ],
    phrases: ["astonishing hypothesis"],
  },
  {
    key: "Dennett1971",
    authors: "Dennett",
    year: 1971,
    citation: "Dennett, 1971",
    tags: ["philosophy-of-mind", "cognitive-science"],
    claim_keys: [
      "intentional stance",
      "design stance",
      "predictive interpretation of behavior",
    ],
    phrases: ["intentional stance"],
  },
  {
    key: "Denzin2012",
    authors: "Denzin",
    year: 2012,
    citation: "Denzin, 2012",
    tags: ["qualitative-methods", "interpretivism", "autoethnography"],
    claim_keys: [
      "interpretive autoethnography",
      "reflexivity",
      "performance ethnography",
    ],
    phrases: ["interpretive autoethnography"],
  },
  {
    key: "Festinger1962",
    authors: "Festinger",
    year: 1962,
    citation: "Festinger, 1962",
    tags: ["social-psychology", "cognition"],
    claim_keys: [
      "cognitive dissonance",
      "dissonance reduction",
      "attitude change",
    ],
    phrases: ["cognitive dissonance"],
  },
  {
    key: "FestingerCarlsmith1959",
    authors: "Festinger & Carlsmith",
    year: 1959,
    citation: "Festinger & Carlsmith, 1959",
    tags: ["social-psychology", "experimental-psychology"],
    claim_keys: [
      "insufficient justification",
      "cognitive dissonance experiment",
      "$1 vs $20 effect",
    ],
    phrases: ["insufficient justification", "dissonance experiment"],
  },
  {
    key: "Feyerabend1975",
    authors: "Feyerabend",
    year: 1975,
    citation: "Feyerabend, 1975",
    tags: ["philosophy-of-science", "methodology", "anarchism-in-method"],
    claim_keys: [
      "epistemological anarchism",
      "theory-ladenness",
      "incommensurability (plural)",
      "methodological pluralism",
    ],
    phrases: ["anything goes", "epistemological anarchism"],
  },
  {
    key: "Fichte1868",
    authors: "Fichte",
    year: 1868,
    citation: "Fichte, 1868",
    tags: ["german-idealism", "selfhood", "transcendental-philosophy"],
    claim_keys: [
      "the I posits itself",
      "self-positing subject",
      "practical reason primacy",
    ],
    phrases: ["the I posits itself"],
  },
  {
    key: "Foucault1980",
    authors: "Foucault",
    year: 1980,
    citation: "Foucault, 1980",
    tags: ["power/knowledge", "discourse", "ideology"],
    claim_keys: [
      "power knowledge",
      "dispositif",
      "discourse",
      "regime of truth",
      "subjectivation",
    ],
    phrases: ["regime of truth", "power/knowledge"],
  },
  {
    key: "Foucault2002",
    authors: "Foucault",
    year: 2002,
    citation: "Foucault, 2002",
    tags: ["archaeology-of-knowledge", "discourse", "method"],
    claim_keys: [
      "discursive formation",
      "archive",
      "statement",
      "rules of formation",
    ],
    phrases: ["discursive formation", "rules of formation"],
  },
  {
    key: "Frankfurt1969",
    authors: "Frankfurt",
    year: 1969,
    citation: "Frankfurt, 1969",
    tags: ["moral-philosophy", "free-will", "responsibility"],
    claim_keys: [
      "principle of alternate possibilities",
      "Frankfurt cases",
      "moral responsibility without alternatives",
    ],
    phrases: ["principle of alternate possibilities", "Frankfurt case"],
  },
  {
    key: "Freire2017",
    authors: "Freire",
    year: 2017,
    citation: "Freire, 2017",
    tags: ["critical-pedagogy", "education", "emancipation"],
    claim_keys: [
      "conscientization",
      "dialogical method",
      "banking model critique",
      "praxis",
    ],
    phrases: ["banking model of education", "conscientization"],
  },
  {
    key: "Fuller2019",
    authors: "Fuller",
    year: 2019,
    citation: "Fuller, 2019",
    tags: ["social-epistemology", "science-policy", "post-truth"],
    claim_keys: [
      "social epistemology",
      "expertise and democracy",
      "post-truth analysis",
    ],
    phrases: ["social epistemology", "post-truth"],
  },
  {
    key: "Gare2017",
    authors: "Gare",
    year: 2017,
    citation: "Gare, 2017",
    tags: ["ontology", "ecological-civilisation", "process-philosophy"],
    claim_keys: [
      "ecological civilisation",
      "process ontology",
      "systemic ethics",
      "civilisational transformation",
    ],
    phrases: ["ecological civilisation"],
  },
  {
    key: "GigerenzerGaissmaier2011",
    authors: "Gigerenzer & Gaissmaier",
    year: 2011,
    citation: "Gigerenzer & Gaissmaier, 2011",
    tags: ["cognitive-psychology", "decision-making", "heuristics"],
    claim_keys: [
      "fast-and-frugal heuristics",
      "ecological rationality",
      "bounded rationality",
      "heuristics-and-biases debate",
    ],
    phrases: ["fast and frugal heuristics", "ecological rationality"],
  },
  {
    key: "Glymour2001",
    authors: "Glymour",
    year: 2001,
    citation: "Glymour, 2001",
    tags: ["causal-inference", "graphical-models", "philosophy-of-science"],
    claim_keys: [
      "Bayes nets",
      "causal discovery",
      "graphical models",
      "psychological inference",
    ],
    phrases: ["Bayes nets", "causal discovery"],
  },
  {
    key: "Godel1992",
    authors: "Gödel",
    year: 1992,
    citation: "Gödel, 1992",
    tags: ["logic", "metamathematics", "foundations"],
    claim_keys: [
      "incompleteness theorems",
      "formal systems limits",
      "arithmetization",
    ],
    phrases: ["incompleteness theorem"],
  },
  {
    key: "Gottlieb2007",
    authors: "Gottlieb",
    year: 2007,
    citation: "Gottlieb, 2007",
    tags: ["developmental-psychology", "psychobiology", "epigenesis"],
    claim_keys: [
      "probabilistic epigenesis",
      "developmental systems",
      "bidirectional causation",
    ],
    phrases: ["probabilistic epigenesis"],
  },
  {
    key: "Hegel1977",
    authors: "Hegel",
    year: 1977,
    citation: "Hegel, 1977",
    tags: ["dialectics", "phenomenology", "sublation"],
    claim_keys: [
      "sublation",
      "recognition",
      "master slave",
      "negation",
      "becoming",
    ],
    phrases: ["master–slave", "sublation"],
  },
  {
    key: "Heidegger1985",
    authors: "Heidegger",
    year: 1985,
    citation: "Heidegger, 1985",
    tags: ["ontology", "phenomenology", "being"],
    claim_keys: [
      "being-in-the-world",
      "temporality",
      "disclosure",
      "thrownness",
      "authenticity",
    ],
    phrases: ["being-in-the-world"],
  },
  {
    key: "HighCourt1992",
    authors: "High Court of Australia",
    year: 1992,
    citation: "High Court of Australia, 1992",
    tags: ["law", "indigenous-rights", "australia"],
    claim_keys: [
      "Mabo decision",
      "native title recognition",
      "overturning terra nullius",
      "land rights jurisprudence",
    ],
    phrases: ["native title", "terra nullius"],
  },
  {
    key: "Hofstadter1999",
    authors: "Hofstadter",
    year: 1999,
    citation: "Hofstadter, 1999",
    tags: ["cognitive-science", "self-reference", "philosophy-of-mind"],
    claim_keys: [
      "strange loops",
      "self-reference",
      "analogy-making",
      "levels of abstraction",
    ],
    phrases: ["strange loop"],
  },
  {
    key: "HowsonUrbach2006",
    authors: "Howson & Urbach",
    year: 2006,
    citation: "Howson & Urbach, 2006",
    tags: [
      "bayesian-epistemology",
      "confirmation-theory",
      "philosophy-of-science",
    ],
    claim_keys: [
      "Bayesian confirmation",
      "probability and evidence",
      "prior and likelihood",
      "updating",
    ],
    phrases: ["Bayesian confirmation"],
  },
  {
    key: "Jaynes2003",
    authors: "Jaynes",
    year: 2003,
    citation: "Jaynes, 2003",
    tags: ["bayesian", "incomplete-knowledge", "inference"],
    claim_keys: [
      "maximum entropy",
      "bayesian inference",
      "prior",
      "posterior",
      "uncertainty",
    ],
    phrases: ["maximum entropy"],
  },
  {
    key: "Kahneman2011",
    authors: "Kahneman",
    year: 2011,
    citation: "Kahneman, 2011",
    tags: ["behavioral-economics", "cognitive-psychology", "decision-making"],
    claim_keys: [
      "System 1 and System 2",
      "heuristics and biases",
      "prospect theory (linkage)",
      "attention and effort",
    ],
    phrases: ["System 1 / System 2", "heuristics and biases"],
  },
  {
    key: "Kant2015",
    authors: "Kant",
    year: 2015,
    citation: "Kant, 2015",
    tags: ["epistemology", "metaphysics", "transcendental-philosophy"],
    claim_keys: [
      "a priori",
      "categories of understanding",
      "transcendental idealism",
      "synthetic a priori",
    ],
    phrases: ["transcendental idealism", "a priori"],
  },
  {
    key: "KnorrCetina1999",
    authors: "Knorr Cetina",
    year: 1999,
    citation: "Knorr Cetina, 1999",
    tags: ["epistemology", "science-studies", "sociology-of-knowledge"],
    claim_keys: [
      "epistemic cultures",
      "laboratory practice",
      "knowledge production",
      "instrumentation",
      "disciplinary styles",
    ],
    phrases: ["epistemic cultures"],
  },
  {
    key: "KolbGibb2011",
    authors: "Kolb & Gibb",
    year: 2011,
    citation: "Kolb & Gibb, 2011",
    tags: ["experiential-learning", "reflective-practice", "education"],
    claim_keys: [
      "experiential learning cycle",
      "reflection-in-action",
      "learning styles (Kolb)",
      "reflective cycle (Gibb)",
    ],
    phrases: ["experiential learning cycle", "reflective cycle"],
  },
  {
    key: "Kuhn1996",
    authors: "Kuhn",
    year: 1996,
    citation: "Kuhn, 1996",
    tags: ["epistemology", "paradigm-shift", "scientific-revolutions"],
    claim_keys: [
      "paradigm",
      "normal science",
      "incommensurability",
      "crisis",
      "revolution",
    ],
    phrases: ["paradigm shift", "normal science"],
  },
  {
    key: "Lacan2007",
    authors: "Lacan",
    year: 2007,
    citation: "Lacan, 2007",
    tags: ["psychoanalysis", "subjectivity", "language"],
    claim_keys: [
      "symbolic",
      "imaginary",
      "real",
      "objet petit a",
      "mirror stage (linkage)",
    ],
    phrases: ["objet petit a", "the Real"],
  },
  {
    key: "Lakatos1978",
    authors: "Lakatos",
    year: 1978,
    citation: "Lakatos, 1978",
    tags: ["methodology", "research-programmes"],
    claim_keys: [
      "research programme",
      "hard core",
      "protective belt",
      "progressive problemshift",
      "degenerating programme",
    ],
    phrases: ["hard core", "protective belt"],
  },
  {
    key: "Libet1985",
    authors: "Libet",
    year: 1985,
    citation: "Libet, 1985",
    tags: ["neuroscience", "free-will", "consciousness"],
    claim_keys: [
      "readiness potential",
      "preconscious initiation",
      "temporal order of awareness",
    ],
    phrases: ["readiness potential"],
  },
  {
    key: "Longino2002",
    authors: "Longino",
    year: 2002,
    citation: "Longino, 2002",
    tags: ["epistemology", "social-knowledge", "science-studies"],
    claim_keys: [
      "social dimensions of knowledge",
      "values in science",
      "pluralism",
      "criticism",
      "transformative criticism",
      "standpoint",
    ],
    phrases: ["transformative criticism"],
  },
  {
    key: "MarcuseKellner2002",
    authors: "Marcuse & Kellner",
    year: 2002,
    citation: "Marcuse & Kellner, 2002",
    tags: ["critical-theory", "technology", "political-philosophy"],
    claim_keys: [
      "one-dimensional society (analysis)",
      "technology and domination",
      "aesthetic dimension (emancipation)",
    ],
    phrases: ["one-dimensional society"],
  },
  {
    key: "Marx1990",
    authors: "Marx",
    year: 1990,
    citation: "Marx, 1990",
    tags: ["ideology", "political-economy", "critique"],
    claim_keys: [
      "commodity fetishism",
      "social relations",
      "alienation",
      "value form",
      "exploitation",
    ],
    phrases: ["commodity fetishism", "value form"],
  },
  {
    key: "Meaney2001",
    authors: "Meaney",
    year: 2001,
    citation: "Meaney, 2001",
    tags: ["neuroscience", "epigenetics", "development"],
    claim_keys: [
      "epigenetic programming",
      "maternal care effects",
      "stress reactivity",
      "methylation",
    ],
    phrases: ["epigenetic programming"],
  },
  {
    key: "MerleauPonty2005",
    authors: "Merleau-Ponty",
    year: 2005,
    citation: "Merleau-Ponty, 2005",
    tags: ["phenomenology", "embodiment", "perception"],
    claim_keys: [
      "lived body",
      "intentional arc",
      "embodied perception",
      "pre-reflective experience",
    ],
    phrases: ["lived body", "embodiment"],
  },
  {
    key: "Miller2003",
    authors: "Miller",
    year: 2003,
    citation: "Miller, 2003",
    tags: ["cognitive-psychology", "history-of-psychology"],
    claim_keys: [
      "cognitive revolution (overview)",
      "information processing",
      "mind as computation",
    ],
    phrases: ["cognitive revolution"],
  },
  {
    key: "Pearl2009",
    authors: "Pearl",
    year: 2009,
    citation: "Pearl, 2009",
    tags: ["causality", "graphs", "counterfactual"],
    claim_keys: [
      "causal graph",
      "do operator",
      "counterfactual",
      "identifiability",
      "backdoor criterion",
    ],
    phrases: ["do operator", "backdoor criterion"],
  },
  {
    key: "Piaget1970",
    authors: "Piaget",
    year: 1970,
    citation: "Piaget, 1970",
    tags: [
      "developmental-psychology",
      "constructivism",
      "genetic-epistemology",
    ],
    claim_keys: [
      "assimilation",
      "accommodation",
      "stages of development",
      "equilibration",
    ],
    phrases: ["assimilation and accommodation"],
  },
  {
    key: "Popper2005",
    authors: "Popper",
    year: 2005,
    citation: "Popper, 2005",
    tags: ["epistemology", "methodology", "falsification"],
    claim_keys: [
      "falsifiability",
      "bold conjectures",
      "severe tests",
      "corroboration",
      "demarcation problem",
    ],
    phrases: ["falsifiable", "bold conjecture"],
  },
  {
    key: "Quine1951",
    authors: "Quine",
    year: 1951,
    citation: "Quine, 1951",
    tags: ["epistemology", "logic", "analytic-synthetic"],
    claim_keys: [
      "two dogmas critique",
      "confirmational holism",
      "web of belief",
      "underdetermination",
    ],
    phrases: ["two dogmas", "web of belief"],
  },
  {
    key: "RoedigerMcDermott1995",
    authors: "Roediger & McDermott",
    year: 1995,
    citation: "Roediger & McDermott, 1995",
    tags: ["memory", "cognitive-psychology", "false-memory"],
    claim_keys: ["DRM paradigm", "false recognition", "associative activation"],
    phrases: ["DRM paradigm", "false memory"],
  },
  {
    key: "Roush2005",
    authors: "Roush",
    year: 2005,
    citation: "Roush, 2005",
    tags: ["epistemology", "reliabilism", "tracking"],
    claim_keys: [
      "tracking theory of knowledge",
      "sensitivity",
      "safety",
      "knowledge-first debates (linkage)",
    ],
    phrases: ["tracking truth", "sensitivity"],
  },
  {
    key: "Rovelli2018",
    authors: "Rovelli",
    year: 2018,
    citation: "Rovelli, 2018",
    tags: ["philosophy-of-physics", "time", "quantum-physics"],
    claim_keys: [
      "relational quantum mechanics",
      "thermal time hypothesis",
      "time as emergent",
    ],
    phrases: ["relational quantum mechanics", "order of time"],
  },
  {
    key: "RCIRCSA2017",
    authors: "RCIRCSA",
    year: 2017,
    citation: "RCIRCSA, 2017",
    tags: [
      "public-inquiry",
      "child-protection",
      "institutional-abuse",
      "australia",
    ],
    claim_keys: [
      "institutional responses",
      "trauma-informed reforms",
      "systemic failure analysis",
      "recommendations",
    ],
    phrases: ["institutional child sexual abuse", "trauma-informed"],
  },
  {
    key: "Taleb2020",
    authors: "Taleb",
    year: 2020,
    citation: "Taleb, 2020",
    tags: ["uncertainty", "fat-tails", "risk"],
    claim_keys: [
      "black swan",
      "fat tails",
      "fragility",
      "antifragile",
      "extreme events",
    ],
    phrases: ["black swan", "fat tails"],
  },
  {
    key: "Tarski1944",
    authors: "Tarski",
    year: 1944,
    citation: "Tarski, 1944",
    tags: ["logic", "semantics", "truth"],
    claim_keys: [
      "semantic conception of truth",
      "T-schema",
      "object language/metalanguage",
    ],
    phrases: ["Convention T", "T-schema"],
  },
  {
    key: "Turkheimer2000",
    authors: "Turkheimer",
    year: 2000,
    citation: "Turkheimer, 2000",
    tags: ["behavioral-genetics", "psychology"],
    claim_keys: [
      "three laws of behavior genetics",
      "heritability context-dependence",
      "nonshared environment",
    ],
    phrases: ["three laws of behavior genetics"],
  },
  {
    key: "vanManen2016",
    authors: "van Manen",
    year: 2016,
    citation: "van Manen, 2016",
    tags: ["phenomenology", "education", "qualitative-research"],
    claim_keys: [
      "phenomenology of practice",
      "lived experience",
      "hermeneutic phenomenology",
    ],
    phrases: ["phenomenology of practice", "lived experience"],
  },
  {
    key: "VarelaThompsonRosch1991",
    authors: "Varela, Thompson, & Rosch",
    year: 1991,
    citation: "Varela, Thompson, & Rosch, 1991",
    tags: [
      "cognitive-science",
      "phenomenology",
      "enactivism",
      "buddhist-psychology",
    ],
    claim_keys: [
      "enactive cognition",
      "embodied mind",
      "experiential method integration",
      "structural coupling",
    ],
    phrases: ["enactive cognition", "embodied mind"],
  },
  {
    key: "Zizek1989",
    authors: "Žižek",
    year: 1989,
    citation: "Žižek, 1989",
    tags: ["ideology", "psychoanalysis", "culture"],
    claim_keys: [
      "ideology critique",
      "fantasy",
      "Lacanian reading of ideology",
      "desire",
    ],
    phrases: ["sublime object of ideology", "ideological fantasy"],
  },
  {
    key: "Zizek2006",
    authors: "Žižek",
    year: 2006,
    citation: "Žižek, 2006",
    tags: ["ideology", "psychoanalysis", "the-real"],
    claim_keys: [
      "ideological fantasy",
      "symbolic",
      "imaginary",
      "the real",
      "parallax view",
    ],
    phrases: ["parallax view", "ideological fantasy"],
  },
  {
    key: "Zizek2008",
    authors: "Žižek",
    year: 2008,
    citation: "Žižek, 2008",
    tags: ["political-theory", "violence", "ideology"],
    claim_keys: [
      "subjective vs objective violence",
      "systemic violence",
      "ideology critique",
    ],
    phrases: ["systemic violence", "objective violence"],
  },

  // --- Additional Seminal Works (DAT Core Domains) ---
  {
    key: "Hegel1807",
    authors: "Hegel",
    year: 1807,
    citation: "Hegel, 1807",
    tags: ["dialectics", "phenomenology", "german-idealism"],
    claim_keys: [
      "recognition",
      "self-consciousness",
      "sublation",
      "master–slave dialectic",
      "becoming",
    ],
    phrases: ["master–slave", "sublation"],
  },
  {
    key: "Marx1867",
    authors: "Marx",
    year: 1867,
    citation: "Marx, 1867",
    tags: ["political-economy", "critique-of-capitalism", "ideology"],
    claim_keys: [
      "surplus value",
      "commodity fetishism",
      "value form",
      "primitive accumulation",
      "exploitation",
    ],
    phrases: ["surplus value", "commodity fetishism"],
  },
  {
    key: "Engels1884",
    authors: "Engels",
    year: 1884,
    citation: "Engels, 1884",
    tags: ["historical-materialism", "family", "political-economy"],
    claim_keys: [
      "origin of the family",
      "property and kinship",
      "historical materialist analysis",
    ],
    phrases: ["origin of the family", "historical materialism"],
  },
  {
    key: "Popper1959",
    authors: "Popper",
    year: 1959,
    citation: "Popper, 1959",
    tags: ["philosophy-of-science", "methodology", "falsification"],
    claim_keys: [
      "falsifiability",
      "conjectures and refutations",
      "demarcation problem",
      "corroboration",
    ],
    phrases: ["conjectures and refutations", "falsifiability"],
  },
  {
    key: "Lakatos1976",
    authors: "Lakatos",
    year: 1976,
    citation: "Lakatos, 1976",
    tags: ["methodology", "research-programmes", "philosophy-of-science"],
    claim_keys: [
      "hard core",
      "protective belt",
      "positive/negative heuristics",
      "progressive/degenerating shifts",
    ],
    phrases: ["research programme", "protective belt"],
  },
  {
    key: "Kuhn1962",
    authors: "Kuhn",
    year: 1962,
    citation: "Kuhn, 1962",
    tags: ["epistemology", "paradigm-shift", "scientific-revolutions"],
    claim_keys: [
      "paradigm",
      "normal science",
      "crisis",
      "revolution",
      "incommensurability",
    ],
    phrases: ["paradigm shift", "normal science"],
  },
  {
    key: "Habermas1984",
    authors: "Habermas",
    year: 1984,
    citation: "Habermas, 1984",
    tags: ["critical-theory", "communication", "social-theory"],
    claim_keys: [
      "communicative rationality",
      "lifeworld and system",
      "discourse ethics",
      "validity claims",
    ],
    phrases: ["communicative rationality", "lifeworld/system"],
  },
  {
    key: "Heidegger1927",
    authors: "Heidegger",
    year: 1927,
    citation: "Heidegger, 1927",
    tags: ["phenomenology", "ontology", "existential-analytics"],
    claim_keys: [
      "Dasein",
      "being-in-the-world",
      "authenticity",
      "temporality",
      "care (Sorge)",
    ],
    phrases: ["Dasein", "being-in-the-world"],
  },
  {
    key: "Sartre1943",
    authors: "Sartre",
    year: 1943,
    citation: "Sartre, 1943",
    tags: ["existentialism", "phenomenology", "freedom"],
    claim_keys: [
      "bad faith",
      "being-for-itself",
      "nothingness",
      "radical freedom",
    ],
    phrases: ["bad faith", "nothingness"],
  },
  {
    key: "Lacan1966",
    authors: "Lacan",
    year: 1966,
    citation: "Lacan, 1966",
    tags: ["psychoanalysis", "language", "subject-formation"],
    claim_keys: [
      "mirror stage",
      "symbolic/imaginary/real",
      "objet petit a",
      "the unconscious is structured like a language",
    ],
    phrases: ["mirror stage", "objet petit a"],
  },
  {
    key: "Žižek1989",
    authors: "Žižek",
    year: 1989,
    citation: "Žižek, 1989",
    tags: ["ideology", "psychoanalysis", "culture"],
    claim_keys: [
      "ideology critique",
      "fantasy",
      "Lacanian reading of ideology",
      "desire",
    ],
    phrases: ["sublime object of ideology", "ideological fantasy"],
  },
  {
    key: "Smith1776",
    authors: "Smith",
    year: 1776,
    citation: "Smith, 1776",
    tags: ["political-economy", "classical-economics"],
    claim_keys: [
      "division of labor",
      "invisible hand",
      "self-interest and markets",
    ],
    phrases: ["invisible hand", "division of labor"],
  },
  {
    key: "Keynes1936",
    authors: "Keynes",
    year: 1936,
    citation: "Keynes, 1936",
    tags: ["macroeconomics", "political-economy"],
    claim_keys: [
      "aggregate demand",
      "animal spirits",
      "fiscal policy",
      "unemployment equilibrium",
    ],
    phrases: ["animal spirits", "aggregate demand"],
  },
  {
    key: "Polanyi1944",
    authors: "Polanyi",
    year: 1944,
    citation: "Polanyi, 1944",
    tags: ["economic-sociology", "political-economy", "history"],
    claim_keys: [
      "embeddedness",
      "double movement",
      "fictitious commodities",
      "market society",
    ],
    phrases: ["embeddedness", "double movement"],
  },
  {
    key: "Hayek1944",
    authors: "Hayek",
    year: 1944,
    citation: "Hayek, 1944",
    tags: ["political-economy", "liberalism", "knowledge-in-society"],
    claim_keys: [
      "knowledge problem",
      "central planning critique",
      "spontaneous order (linkage)",
    ],
    phrases: ["knowledge problem", "central planning"],
  },
  {
    key: "Lenin1917",
    authors: "Lenin",
    year: 1917,
    citation: "Lenin, 1917",
    tags: ["political-theory", "marxism", "state"],
    claim_keys: [
      "state and revolution",
      "withering away of the state",
      "dictatorship of the proletariat",
    ],
    phrases: ["dictatorship of the proletariat", "state and revolution"],
  },
  {
    key: "Luxemburg1913",
    authors: "Luxemburg",
    year: 1913,
    citation: "Luxemburg, 1913",
    tags: ["marxism", "political-economy", "imperialism"],
    claim_keys: [
      "accumulation of capital",
      "imperialism critique",
      "markets and expansion",
    ],
    phrases: ["accumulation of capital", "imperialism"],
  },
  {
    key: "Jaynes2003",
    authors: "Jaynes",
    year: 2003,
    citation: "Jaynes, 2003",
    tags: ["bayesian", "incomplete-knowledge", "inference"],
    claim_keys: [
      "maximum entropy",
      "bayesian inference",
      "prior",
      "posterior",
      "uncertainty",
    ],
    phrases: ["maximum entropy"],
  },
  {
    key: "Toulmin1958",
    authors: "Toulmin",
    year: 1958,
    citation: "Toulmin, 1958",
    tags: ["argumentation", "rhetoric", "epistemology"],
    claim_keys: [
      "warrant",
      "backing",
      "rebuttal",
      "data-claim relation",
      "Toulmin model",
    ],
    phrases: ["warrant", "Toulmin model"],
  },
];
export default referencePool;
